import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
const homeLoginPopUpEventHandler = SingleEventHandler();
export const loginPopUpHandlerProps = {
  listenClose: homeLoginPopUpEventHandler.listen,
  stopListeningClose: homeLoginPopUpEventHandler.stopListening
};
export const homeLoginPopUp = {
  close: homeLoginPopUpEventHandler.trigger
};
export const removeFeedbackPrime = Odigeo => Odigeo.trigger('frontend-shell:loginSuccess');
export const onOpenMenuMobile = Odigeo => Odigeo.trigger('frontend-shell:openOF2Menu');